// @flow
import React, { useState } from "react";
import { Typography } from "src/latest/src/components";
import "./ca-filter-container.scss";
import AutocompleteDropdown from "./AutocompleteDropdown";
import TimeImage from "../../base/TimePicker/TimePicker";
import { useIsMobile } from "src/latest/src/hooks";
import { TypeAheadLocationSearch } from "src/latest/src";

export type AvailabilityFilter = {
    timeFrom: string;
    timeTo: string;
    weekDaysFilter: string[];
};

type Props = {
    className?: string,
    selectedFilters?: Object,
    searchUpdatedFilter: Object,
    availabilityFilter?: AvailabilityFilter,
    setSearchUpdatedFilter: Function,
    handleAvailabilityFilter: Function,
    calenderServiceFilters:Array,
    handleScheduleFilterUpdate:Function,
    insuranceList : Array,
};


export default function CAFilterContainer({
    selectedFilters,
    searchUpdatedFilter,
    availabilityFilter,
    setSearchUpdatedFilter,
    handleAvailabilityFilter,
    calenderServiceFilters,
    handleScheduleFilterUpdate,
}: Props): React$Element<any> {
    const filterGroups = [
        {
            key: "LOCATION_AND_MEETING_PREFERENCE",
            title: "Location & meeting preference",
        },
        {
            key: "COMMONLY_USED",
            title: "Commonly used filters",
        },
        {
            key: "AVAILABILITY",
            title: "Availability",
        },
        {
            key: "IDENTITIES",
            title: "Identities",
        },
        {
            key: "LANGUAGE_AND_FEES",
            title: "Language and fees",
        },
    ];
    const [prevValueTo,setPrevValueTo] = useState({});
    const [prevValueFrom,setPrevValueFrom] = useState({});
    const isFromMobile = useIsMobile();

    const onFilterValueUpdated = (filter, selectedValue) => {
        let currentFilter = { ...filter };

       selectedValue?.unique_key === "feeToClientUniqueKey" && setPrevValueTo(selectedValue);
       selectedValue?.unique_key === "feeFromClientUniqueKey" && setPrevValueFrom(selectedValue);

        if(!calenderServiceFilters.includes(filter.filter_key)){
            if (filter.filter_component_type === "multi-checkbox") {
                currentFilter.filter_selection_data = selectedValue;
            } else if (filter.filter_component_type === "single-select") {
                currentFilter.filter_selection_data = selectedValue
                    ? [selectedValue]
                    : [];
                selectedValue = selectedValue ? [selectedValue] : [];
            } else if (filter.filter_component_type === "text-field") {
                currentFilter = { ...filter };

                currentFilter.filter_selection_data =
                    currentFilter.filter_selection_data
                        .map((el) => {
                            if (el.unique_key === selectedValue.unique_key) {
                                return selectedValue;
                            } else {
                                if(el.unique_key ==="feeFromClientUniqueKey"){
                                    return prevValueFrom;
                                } else if(el.unique_key ==="feeToClientUniqueKey"){
                                return prevValueTo;
                                } else {
                                    return undefined;
                                }
                            }
                        })
                        ?.filter((el) => el?.value);
            } else if (filter.filter_component_type === "location-search") {
                if (currentFilter.filter_selection_data[0]) {
                    currentFilter.filter_selection_data[0].value = selectedValue ? JSON.stringify(selectedValue) : "";
                }
            }

            const filterIndex = searchUpdatedFilter.findIndex(
                (el) => el.filter_key === currentFilter.filter_key
            );

            const filters = [...searchUpdatedFilter];

            if (filterIndex > -1) {
                if (selectedValue?.length === 0) {
                    filters.splice(filterIndex, 1);
                } else {
                    filters[filterIndex] = currentFilter;
                }
            } else {
                filters.push(currentFilter);
            }

            setSearchUpdatedFilter(filters);
    }else if(calenderServiceFilters.includes(filter.filter_key)){
        let selectedVal = [];

         if (filter.filter_component_type === "multi-checkbox") {
            selectedVal = selectedValue;
            handleScheduleFilterUpdate({...filter},selectedVal,currentFilter.filter_selection_data[selectedValue]);

           
        } else if (filter.filter_component_type === "single-select") {
            currentFilter.filter_selection_data = selectedValue
                ? [selectedValue]
                : [];
            selectedVal = selectedValue ? [selectedValue] : [];
            handleScheduleFilterUpdate({...filter},selectedVal);
        }
    }
    };

    return (
        <div className="ca-filters-container">
            {!isFromMobile && (
                <Typography
                    variant="size-18"
                    className="mb-4"
                    weight="bold"
                    color="color-28"
                >
                    Filter Clinicians by:
                </Typography>
            )}
            <FilterSubHeader text="Availability" />
            <TimeImage
                selectedDayOfWeek={availabilityFilter?.weekDaysFilter}
                selectedStartTime={availabilityFilter?.timeFrom}
                selectedEndTime={availabilityFilter?.timeTo}
                handleAvailabilityFilter={handleAvailabilityFilter}
            />
            {selectedFilters?.filters &&
                selectedFilters?.filters?.map((filter, index) => {
                    const type = filter.filter_component_type;
                    const currentGroup = filter.filter_group;
                    const previousGroup =
                        selectedFilters?.filters[index - 1]?.filter_group;

                    let filterSubHeader;

                    if (currentGroup !== previousGroup) {
                        filterSubHeader = (
                            <FilterSubHeader
                                text={
                                    filterGroups?.find(
                                        (f) => f.key === currentGroup
                                    )?.title
                                }
                            />
                        );
                    }

                    switch (type) {
                        case "location-search": {
                            return (
                                <div key={filter.filter_key}>
                                    {filterSubHeader}
                                    <div className="ca-filter">
                                        <div className="row">
                                            <TypeAheadLocationSearch
                                                onLocationSelection={(
                                                    value
                                                ) => {
                                                    onFilterValueUpdated(
                                                        filter,
                                                        value
                                                    );
                                                }}
                                                choices={filter?.filter_selection_data}
                                                disabled={filter.locked}
                                                type="CAfilters"
                                            />
                                        </div>
                                    </div>
                                </div>
                            );
                        }

                        case "single-select":

                        // eslint-disable-next-line no-fallthrough
                        case "multi-checkbox": {
                            return (
                                <div key={filter.filter_key}>
                                    {filterSubHeader}
                                    <div className="ca-filter">
                                        <AutocompleteDropdown
                                            type={type}
                                            index={index}
                                            filter={filter}
                                            checkbox={type === "multi-checkbox"}
                                            onFilterValueUpdated={
                                                onFilterValueUpdated
                                            }
                                            disabled={filter.locked}
                                            sx={{ width: "100%", m: 1 }}
                                            isGrouped={filter.is_grouped}
                                        />
                                    </div>
                                </div>
                            );
                        }

                        case "text-field": {
                            return (
                                <div key={filter.filter_key}>
                                    {filterSubHeader}
                                    <div className="ca-filter">
                                        <div className="row">
                                            {filter?.filter_selection_data?.map(
                                                (input) => {
                                                    return (
                                                        <div
                                                            key={
                                                                input.unique_key
                                                            }
                                                        >
                                                            <input
                                                                className="text-field-input"
                                                                defaultValue={
                                                                    input.value
                                                                }
                                                                onChange={(
                                                                    event
                                                                ) => {
                                                                    const value =
                                                                        event
                                                                            .target
                                                                            .value;

                                                                    onFilterValueUpdated(
                                                                        filter,
                                                                        {
                                                                            ...input,
                                                                            value,
                                                                        }
                                                                    );
                                                                }}
                                                                onInput={(
                                                                    event
                                                                ) => {
                                                                    event.target.value =
                                                                        event.target.value.replace(
                                                                            /\D/g,
                                                                            ""
                                                                        );

                                                                    if (
                                                                        event
                                                                            .target
                                                                            .value
                                                                            .length >
                                                                        4
                                                                    ) {
                                                                        event.target.value =
                                                                            event.target.value.slice(
                                                                                0,
                                                                                4
                                                                            );
                                                                    }
                                                                }}
                                                                placeholder={
                                                                    input.place_holder
                                                                }
                                                                inputMode="numeric"
                                                                pattern="[0-9]*"
                                                            />
                                                        </div>
                                                    );
                                                }
                                            )}
                                        </div>
                                    </div>
                                </div>
                            );
                        }

                        default: {
                            return (
                                <div key={filter.filter_key}>
                                    {filterSubHeader}
                                </div>
                            );
                        }
                    }
                })}
        </div>
    );
}

const FilterSubHeader = ({ text }) => {
    return (
        <Typography
            variant="size-12"
            className="mb-3 mt-4 text-uppercase"
            weight="700"
            color="color-28"
        >
            {text}
        </Typography>
    );
};
